import { render } from "./AppFooter.vue?vue&type=template&id=3bdfb35e&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=3bdfb35e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bdfb35e"

export default script